"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_loops_1 = require("react-loops");
const constants_1 = require("../constants");
const react_2 = require("@osmosys/react");
const AwesomeResourceCard_1 = require("../AwesomeResourceCard");
const DemoSelectBox_1 = require("./DemoSelectBox");
const react_if_1 = require("react-if");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../comps/reusables");
const constants_2 = require("../../constants");
const inputs_1 = require("..");
const react_use_1 = require("react-use");
const moment_1 = tslib_1.__importDefault(require("moment"));
const hooks_1 = require("../../hooks");
exports.AwesomeResourceDebugPage = () => {
    var _a;
    const { currentWorkspace } = hooks_1.useOsmosysContext();
    const [state, setLocalStorage] = react_use_1.useLocalStorage(`debug:resources:options:v1:ws:${(_a = currentWorkspace) === null || _a === void 0 ? void 0 : _a.id}:${moment_1.default().format('l')}`, {
        activated: false,
        boldLabels: false,
        clearable: false,
        cms: null,
        disabled: false,
        emailList: null,
        emailTemplate: null,
        esp: null,
        integrationTypes: [],
        overrideLabels: false,
        selectFirstIfNoValue: false,
        showLabels: true,
        useCustomProps: false,
    });
    const setState = react_1.useCallback(newState => {
        return setLocalStorage(Object.assign(Object.assign({}, state), newState));
    }, [state]);
    // if (!state) {
    //   return null;
    // }
    return (react_1.default.createElement(react_2.OsmosysDiv, { className: "overflow-hidden", flexColFilled: true },
        react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true, className: "bg-white border-bottom" },
            react_1.default.createElement(react_2.OsmosysDiv, { flexRowCenteredFilled: true },
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, padding: true, borderRight: true, borderLeft: true },
                    react_1.default.createElement(react_2.OsmosysToggler, { id: "useCustomProps", on: state.useCustomProps, onLabel: "Custom options", offLabel: "Standard options", toggle: checked => {
                            setState({
                                useCustomProps: checked,
                            });
                        } })),
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, padding: true, borderRight: true },
                    react_1.default.createElement(react_2.OsmosysToggler, { id: "showLabels", on: state.showLabels, disabled: !state.useCustomProps, onLabel: "Labels", offLabel: "No labels", toggle: checked => {
                            setState({
                                showLabels: checked,
                            });
                        } })),
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, padding: true, borderRight: true },
                    react_1.default.createElement(react_2.OsmosysToggler, { id: "boldLabels", on: state.boldLabels, disabled: !state.useCustomProps, onLabel: "Bold labels", offLabel: "No bolded labels", toggle: checked => {
                            setState({
                                boldLabels: checked,
                            });
                        } })))),
        react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true, className: "bg-white border-bottom shadow-sm" },
            react_1.default.createElement(react_2.OsmosysDiv, { flexRowCenteredFilled: true },
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, padding: true, borderRight: true, borderLeft: true },
                    react_1.default.createElement(react_2.OsmosysToggler, { id: "overrideLabels", on: state.overrideLabels, disabled: !state.useCustomProps, onLabel: "Override labels", offLabel: "No overriden labels", toggle: checked => {
                            setState({
                                overrideLabels: checked,
                            });
                        } })),
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, padding: true, borderRight: true },
                    react_1.default.createElement(react_2.OsmosysToggler, { id: "disabled", on: state.disabled, disabled: !state.useCustomProps, onLabel: "Disabled", offLabel: "Enabled", toggle: checked => {
                            setState({
                                disabled: checked,
                            });
                        } })),
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, padding: true, borderRight: true },
                    react_1.default.createElement(react_2.OsmosysToggler, { id: "clearable", on: state.clearable, disabled: !state.useCustomProps, onLabel: "Clearable", offLabel: "Not clearable", toggle: checked => {
                            setState({
                                clearable: checked,
                            });
                        } })),
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, padding: true, borderRight: true },
                    react_1.default.createElement(react_2.OsmosysToggler, { id: "selectFirstIfNoValue", on: state.selectFirstIfNoValue, disabled: !state.useCustomProps, onLabel: "Select if no value set", offLabel: "Leave empty", toggle: checked => {
                            setState({
                                selectFirstIfNoValue: checked,
                            });
                        } })))),
        react_1.default.createElement(react_2.OsmosysDiv, { id: "scroll-container", className: "overflow-y-auto" },
            react_1.default.createElement(react_loops_1.For, { in: constants_1.AWESOME_RESOURCE_CONFIG }, (resource, { key: resourceName }) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                const singleStateKey = `${resourceName}.single`;
                const demoSelectProps = {
                    cmsId: (_a = state.cms) === null || _a === void 0 ? void 0 : _a.id,
                    config: resource,
                    developmentVersionId: (_c = (_b = state.emailTemplate) === null || _b === void 0 ? void 0 : _b.developmentVersion) === null || _c === void 0 ? void 0 : _c.id,
                    emailTemplateId: (_d = state.emailTemplate) === null || _d === void 0 ? void 0 : _d.id,
                    espId: (_e = state.esp) === null || _e === void 0 ? void 0 : _e.id,
                    integrationTypes: state.integrationTypes.map(o => {
                        return o.value;
                    }),
                    listEspId: (_f = state.emailList) === null || _f === void 0 ? void 0 : _f.espId,
                    listId: (_g = state.emailList) === null || _g === void 0 ? void 0 : _g.id,
                    productionVersionId: (_j = (_h = state.emailTemplate) === null || _h === void 0 ? void 0 : _h.productionVersion) === null || _j === void 0 ? void 0 : _j.id,
                    resourceName,
                    stagingVersionId: (_l = (_k = state.emailTemplate) === null || _k === void 0 ? void 0 : _k.stagingVersion) === null || _l === void 0 ? void 0 : _l.id,
                };
                const sharedCustomProps = state.useCustomProps
                    ? {
                        boldLabel: state.boldLabels,
                        clearable: state.clearable,
                        disabled: state.disabled,
                        label: state.showLabels,
                        labelOverride: state.overrideLabels
                            ? 'Custom label'
                            : undefined,
                        resource: resourceName,
                        selectFirstIfNoValue: state.selectFirstIfNoValue,
                    }
                    : undefined;
                const sharedProps = Object.assign({ activated: state.activated }, sharedCustomProps);
                const singleProps = Object.assign(Object.assign({}, sharedProps), { onChange: (v) => {
                        setState({
                            [singleStateKey]: v,
                        });
                    }, value: state[singleStateKey] });
                const multiStateKey = `${resourceName}.multi`;
                const multiProps = Object.assign(Object.assign({}, sharedProps), { multiple: true, onChange: (v) => {
                        setState({
                            [multiStateKey]: v,
                        });
                    }, value: state[multiStateKey] });
                const single = (react_1.default.createElement(DemoSelectBox_1.DemoSelectBox, Object.assign({}, demoSelectProps, { sharedProps: singleProps })));
                const singleCard = (react_1.default.createElement(reactstrap_1.Card, { className: "p-3 m-2" },
                    react_1.default.createElement("p", { className: "lead mb-2 mt-1" }, "Single select"),
                    single,
                    react_1.default.createElement(react_if_1.When, { condition: !!state[singleStateKey] },
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(AwesomeResourceCard_1.AwesomeResourceCard, { resource: resourceName, data: state[singleStateKey], marginBottom: true }))));
                const multi = (react_1.default.createElement(DemoSelectBox_1.DemoSelectBox, Object.assign({}, demoSelectProps, { sharedProps: multiProps })));
                const multiCard = (react_1.default.createElement(reactstrap_1.Card, { className: "p-3 m-2" },
                    react_1.default.createElement("p", { className: "lead mb-2 mt-1" }, "Multi select"),
                    multi,
                    react_1.default.createElement(react_if_1.When, { condition: state[multiStateKey] && state[multiStateKey].length > 0 },
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(react_loops_1.For, { of: state[multiStateKey] }, r => {
                            return (react_1.default.createElement(AwesomeResourceCard_1.AwesomeResourceCard, { resource: resourceName, data: r, marginBottom: true }));
                        }))));
                const meta = (react_1.default.createElement(react_2.OsmosysDiv, { style: { width: 450 } },
                    react_1.default.createElement(react_if_1.When, { condition: resourceName === 'integration' },
                        react_1.default.createElement(reactstrap_1.FormGroup, null,
                            react_1.default.createElement(reactstrap_1.Label, null, "Integration types"),
                            react_1.default.createElement(reusables_1.SelectBox, { options: constants_2.INTEGRATION_OPTIONS, value: state.integrationTypes, isMulti: true, onChange: integrationTypes => {
                                    setState({
                                        integrationTypes,
                                    });
                                } }))),
                    react_1.default.createElement(react_if_1.When, { condition: resourceName === 'emailTemplateVersion' },
                        react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { value: state.emailTemplate, resource: "emailTemplate", onChange: (emailTemplate) => {
                                setState({
                                    emailTemplate,
                                });
                            } })),
                    react_1.default.createElement(react_if_1.When, { condition: resourceName === 'emailList' ||
                            resourceName === 'emailSegment' },
                        react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { value: state.esp, resource: "integration", integrationTypes: [
                                'CampaignMonitor',
                                'Mailchimp',
                                'Mailjet',
                                'Sailthru',
                                'Salesforce',
                                'ActiveCampaign',
                            ], onChange: (esp) => {
                                setState({
                                    esp,
                                });
                            } }),
                        react_1.default.createElement(react_2.OsmosysToggler, { id: `${resourceName}.activatedCheckBox`, on: state.activated, toggle: newActivated => {
                                setState({
                                    activated: newActivated,
                                });
                            }, onLabel: "Activated", offLabel: "Deactivated", centered: true }, "Activated"),
                        react_1.default.createElement(react_if_1.When, { condition: resourceName === 'emailSegment' },
                            react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { value: state.emailList, resource: "emailList", activated: state.activated, espId: (_m = state.esp) === null || _m === void 0 ? void 0 : _m.id, onChange: (emailList) => {
                                    setState({
                                        emailList,
                                    });
                                } }))),
                    react_1.default.createElement(react_if_1.When, { condition: resourceName === 'contentMapping' ||
                            resourceName === 'contentFeed' ||
                            resourceName === 'contentConversion' },
                        react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { value: state.cms, resource: "integration", integrationTypes: ['ContentSystem'], onChange: (cms) => {
                                setState({
                                    cms,
                                });
                            } }))));
                return (react_1.default.createElement(react_2.OsmosysDiv, { id: resourceName, className: ['border-bottom', 'mb-3', 'pb-3 pt-3'], flexCol: true },
                    react_1.default.createElement(react_2.OsmosysDiv, { flexRowCentered: true },
                        react_1.default.createElement(react_2.OsmosysDiv, { className: "mb-2", style: { width: 450 } },
                            react_1.default.createElement("h3", { className: "text-center m-0" },
                                react_1.default.createElement(react_2.OsmosysChangeCase, { type: "sentenceCase" }, resourceName)))),
                    react_1.default.createElement(react_2.OsmosysDiv, { flexRowCentered: true }, meta),
                    react_1.default.createElement(react_2.OsmosysDiv, { flexRowCentered: true },
                        react_1.default.createElement(react_2.OsmosysDiv, { flexRowCenteredFilled: true },
                            react_1.default.createElement(react_2.OsmosysDiv, { style: { width: 450 } }, singleCard),
                            react_1.default.createElement(react_2.OsmosysDiv, { style: { width: 450 } }, multiCard)))));
            }))));
};
exports.default = exports.AwesomeResourceDebugPage;
//# sourceMappingURL=index.js.map